module.exports = __webpack_public_path__ + "static/portfolio-5-06f86f0e2382397e9155f5d852a6e8df.jpg";